// Import de bibliotecas principais
import React from 'react'

// Import de elementos de estilização, componentes gerais e de layout
import { motion } from 'framer-motion/dist/framer-motion'

import './Header.scss'

export function HeaderExtra() {
	return (
		<motion.header
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className="header"
		>
			AAAAAAAAAAAAAAAAAAa HEADER
		</motion.header>
	)
}
